import React from 'react'

type Props = {
  className?: string
  hasLogo: boolean
  logoToDisplay: string
}

const Logo: React.FC<Props> = ({ className, hasLogo, logoToDisplay }) => {
  return (
    //Todo: Check later to see if this class will be usefull in the future
    <div className={`${className}-logo ${hasLogo ? 'hasLogo' : ''}`}>
      {hasLogo ? (
        <img
          alt={`Logo: ${logoToDisplay}`}
          className={`${className}-logo-image`}
          src={`${logoToDisplay}?format=webp`}
        />
      ) : (
        <p className={`${className}-logo-title`}>{logoToDisplay}</p>
      )}
    </div>
  )
}

export default Logo
